import { Card } from "antd";
import React from "react";
import { MdOutlineSendToMobile } from "react-icons/md";
const PaymentModes = ({
  mode,
  selectMode,
}) => {
  return (
   <>
     <div className="payment-sec">
          <div className="card_header">
            <span>Payment Method</span>
            <span>
              <img src="images/payment-money.png" />
            </span>
          </div>
          <Card className="payment-card">
            <div className="small text-gray ff-lato">Choose a payment method</div>
            <div className="pay__option__box">
              <div
                className={mode === "mobile" ? "pay__option cash-padding active" : "pay__option cash-padding"}
                onClick={() => selectMode("mobile")}
              >
                <MdOutlineSendToMobile />
                <p className={mode === "mobile" ? "pay-type color" : "pay-type"}>Mobile</p>
              </div>
            </div>
          </Card>
        </div>
   </>
  );
};

export default PaymentModes;
